import React from 'react';
import { useColorContext } from '../../context/colorContext';

// Fixed brand colors (aligned with the app palette) that do not change with theme/context.
const BRAND_LOGO_TEXT = '#111111';
const BRAND_LOGO_ACCENT = '#7C3AED';

const toSafeHex = (hex, fallback) => {
	const value = String(hex || '').trim();
	return /^#([A-Fa-f0-9]{6})$/.test(value) ? value : fallback;
};

const hexToRgba = (hex, alpha, fallback) => {
	const safeHex = toSafeHex(hex, fallback);
	const r = parseInt(safeHex.slice(1, 3), 16);
	const g = parseInt(safeHex.slice(3, 5), 16);
	const b = parseInt(safeHex.slice(5, 7), 16);
	return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export default function BrandLogo({ size = 22, style = {}, className = '' }) {
	const { resolvedThemeType } = useColorContext();
	const safeTextPrimary = toSafeHex(BRAND_LOGO_TEXT, '#FFFFFF');
	const safeAccent = toSafeHex(BRAND_LOGO_ACCENT, '#6366F1');
	const isDarkTheme = String(resolvedThemeType || '').toLowerCase() === 'dark';

	return (
		<span
			className={className}
			style={{
				display: 'inline-block',
				fontSize: size,
				fontWeight: 700,
				fontStyle: 'italic',
				letterSpacing: 0.5,
				textTransform: 'uppercase',
				color: isDarkTheme ? '#7C3AED' : undefined,
				background: isDarkTheme
					? 'none'
					: `linear-gradient(135deg, ${safeTextPrimary} 0%, ${hexToRgba(safeAccent, 0.82, safeAccent)} 100%)`,
				WebkitBackgroundClip: isDarkTheme ? undefined : 'text',
				WebkitTextFillColor: isDarkTheme ? undefined : 'transparent',
				backgroundClip: isDarkTheme ? undefined : 'text',
				lineHeight: 1,
				whiteSpace: 'nowrap',
				...style,
			}}
		>
			PLYNOTE
		</span>
	);
}